import styled from 'styled-components';

export const ModalContent = styled.div`
  top: 370px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 24px;
  z-index: 1001;
  overflow: auto;
`;

export const ModalTitle = styled.p`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.typography.size.title};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  padding-bottom: 10px;
`;
